import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { EIPDateRangePickerComponent } from "eipdate-range-picker";
import { FieldConfig } from "../../interface/field.interface";

@Component({
    selector: 'form-field-datarange',
    templateUrl: './eipdaterange.component.html'
})
export class EipDateRangeComponent implements OnInit, AfterViewInit {
    @ViewChild('dateRangePicker') dateRange!: EIPDateRangePickerComponent;
    isSelectionRequired: boolean = true;
    startDate!: Date;
    endDate!: Date;
    field!: FieldConfig;
    group!: FormGroup;
    formName: string = '';

    constructor() { }

    ngOnInit() {
        if (this.field.Var) {
            this.startDate = null
            this.endDate = null;
        }
        else {
             this.startDate = this.field.startDate ? this.field.startDate : new Date();
             this.endDate = this.field.endDate ? this.field.endDate : new Date();
        }
        if (this.field.rangeControlNames) {
            this.group.get(this.field.rangeControlNames[0])?.setValue(this.startDate)
            this.group.get(this.field.rangeControlNames[1])?.setValue(this.endDate)
            //Update the startdate & enddate of daterange control, whenever changes in form control value update 
            this.group.get(this.field.rangeControlNames[0])?.valueChanges.subscribe(x => this.startDate = x)
            this.group.get(this.field.rangeControlNames[1])?.valueChanges.subscribe(x => this.endDate = x)
        }
    }

    ngAfterViewInit() {
        if (!!this.field.minDate) {
            this.dateRange.Min = new Date(this.field.minDate);
        }
        if (!!this.field.maxDate) {
            this.dateRange.Max = new Date(this.field.maxDate);
        }
        //Update daterange, min & max date - Whenever changes are done in (field: FieldConfig) value
        if (this.field.value)
            this.field.value.subscribe((x: any[]) => {
                if (x && x.length == 2) {
                    this.setStartDateValue(x[0] ? new Date(x[0]) : null);
                    this.setEndDateValue(x[1] ? new Date(x[1]) : null);
                }
                if (!!this.field.minDate) {
                    this.dateRange.Min = new Date(this.field.minDate);
                }
                if (!!this.field.maxDate) {
                    this.dateRange.Max = new Date(this.field.maxDate);
                }
            });
    }

    getWaterMark(): string {
        return this.field.label ? this.field.label : '';
    }

    closedate(selectedText: Date, selectedText1: Date) {
        if (selectedText && this.field.rangeControlNames)
            this.group.get(this.field.rangeControlNames[0])?.setValue(null);
        if (selectedText && this.field.rangeControlNames)
            this.group.get(this.field.rangeControlNames[1])?.setValue(null);
    }
    getId(): string {
        return this.formName + this.field.name;
    }

    setStartDateValue(selectedText: Date) {
        if (selectedText && this.field.rangeControlNames)
            this.group.get(this.field.rangeControlNames[0])?.setValue(selectedText);
        // else
        //     this.group.get(this.field.rangeControlNames[0])?.setValue(null);
    }

    setEndDateValue(selectedText: Date) {
        if (selectedText && this.field.rangeControlNames)
            this.group.get(this.field.rangeControlNames[1])?.setValue(selectedText);
        // else
        //     this.group.get(this.field.rangeControlNames[1])?.setValue(null);
    }
}